/**
 * Minimal shim for react-native-reanimated on web.
 *
 * Inert animations are fine for the browse-only web app; the important part
 * is that module-scope consumers (react-native-gesture-handler's
 * GestureButtons, keyboard-controller, AnimatedTabBar) get everything they
 * touch at import time.
 */
const RN = require('react-native');

// Identity passthrough: the shim has no animation runtime, so an "animated"
// component is just the plain component.
const Animated = {
  createAnimatedComponent: (Component) => Component,
  View: RN.View,
  Text: RN.Text,
  ScrollView: RN.ScrollView,
  Value: function Value(v) { this.value = v; },
  ValueXY: function ValueXY(v) { this.value = v; },
  event: () => () => {},
  timing: () => ({ start() {} }),
  spring: () => ({ start() {} }),
};

module.exports = {
  __esModule: true,
  default: Animated,
  Animated,
  ...Animated,
  useSharedValue: (v) => ({ value: v }),
  useAnimatedStyle: (fn) => (fn ? fn() : {}),
  useAnimatedReaction: () => {},
  useDerivedValue: (fn) => ({ value: fn ? fn() : undefined }),
  useAnimatedGestureHandler: () => {},
  useAnimatedScrollHandler: () => {},
  useAnimatedProps: (fn) => (fn ? fn() : {}),
  withTiming: (v) => v,
  withSpring: (v) => v,
  withDecay: (v) => v,
  cancelAnimation: () => {},
  runOnJS: (fn) => fn,
  interpolate: (v) => v,
  Extrapolation: { CLAMP: 'clamp', EXTEND: 'extend', IDENTITY: 'identity' },
  Easing: new Proxy({ linear: (t) => t }, {
    get: (t, p) => t[p] || (() => (x) => x),
  }),
};